/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Tasks_Group_By_TypeInputs */

const en_my_tasks_group_by_type = /** @type {(inputs: My_Tasks_Group_By_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group by activity type`)
};

const pt_br2_my_tasks_group_by_type = /** @type {(inputs: My_Tasks_Group_By_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agrupar por tipo de atividade`)
};

/**
* | output |
* | --- |
* | "Group by activity type" |
*
* @param {My_Tasks_Group_By_TypeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const my_tasks_group_by_type = /** @type {((inputs?: My_Tasks_Group_By_TypeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Tasks_Group_By_TypeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_my_tasks_group_by_type(inputs)
	return pt_br2_my_tasks_group_by_type(inputs)
});